import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18next';

// Main CSS
import './assets/global.scss';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
